import { SearchMode } from '#pplx/frontend/ask-models/types/search-modes.js';
import { defineMessage, defineMessages } from 'react-intl';
export const SearchModeStrings = {
    [SearchMode.SEARCH]: defineMessages({
        /**
         * @deprecated use getSearchModeLabel function instead
         */
        name: {
            defaultMessage: 'Search',
            id: '35e9419c88',
            description: 'Display name for the Search mode in the mode selector',
        },
        description: {
            defaultMessage: 'Get fast answers to everyday questions',
            id: 'abb0a83660',
            description: 'Subtitle describing the Search mode in the mode selector',
        },
        suggestionTooltip: {
            defaultMessage: 'Use search: get fast answers to everyday questions',
            id: 'be36179082',
            description: 'Tooltip describing the Search mode suggestion',
        },
    }),
    [SearchMode.RESEARCH]: defineMessages({
        /**
         * @deprecated use getSearchModeLabel function instead
         */
        name: {
            defaultMessage: 'Deep research',
            id: '431f2ef198',
            description: 'Display name for the Deep Research mode in the mode selector',
        },
        description: {
            defaultMessage: 'Create in-depth reports with more sources, charts, and advanced reasoning',
            id: '0d337103b8',
            description: 'Subtitle describing the Deep Research mode in the mode selector',
        },
        suggestionTooltip: {
            defaultMessage: 'Use deep research: create in-depth reports with more sources, charts, and advanced reasoning',
            id: '21b0a4e04a',
            description: 'Tooltip describing the Deep Research mode suggestion',
        },
    }),
    [SearchMode.STUDY]: defineMessages({
        /**
         * @deprecated use getSearchModeLabel function instead
         */
        name: {
            defaultMessage: 'Learn step by step',
            id: '4a8287a7e0',
            description: 'Display name for the Study mode in the mode selector',
        },
        description: {
            defaultMessage: 'Study and understand topics with interactive questions',
            id: 'c2e0a9a144',
            description: 'Subtitle describing the Study mode in the mode selector',
        },
        suggestionTooltip: {
            defaultMessage: 'Learn step by step: study and understand topics with interactive questions',
            id: '1acedfa177',
            description: 'Tooltip describing the Study mode suggestion',
        },
    }),
    [SearchMode.AGENTIC_RESEARCH]: defineMessages({
        /**
         * @deprecated use getSearchModeLabel function instead
         */
        name: {
            defaultMessage: 'Model council',
            id: '7c57db79dc',
            description: 'Display name for the Model Council mode in the mode selector',
        },
        description: {
            defaultMessage: 'Consult multiple AI models at once for research, complex decisions, or verification.',
            id: 'f59607eec8',
            description: 'Subtitle describing the Model Council mode in the mode selector',
        },
        suggestionTooltip: {
            defaultMessage: 'Use model council: consult multiple AI models at once for research, complex decisions, or verification.',
            id: '3aa636f1e9',
            description: 'Tooltip describing the Model Council mode suggestion',
        },
    }),
    [SearchMode.BROWSER_AGENT]: defineMessages({
        /**
         * @deprecated use getSearchModeLabel function instead
         */
        name: {
            defaultMessage: 'Control browser',
            id: 'ad64c885bb',
            description: 'Display name for the Browser Agent mode in the mode selector',
        },
        description: {
            defaultMessage: 'Autonomously browse the web to complete tasks for you',
            id: '14465b11f3',
            description: 'Subtitle describing the Browser Agent mode in the mode selector',
        },
        suggestionTooltip: {
            defaultMessage: 'Control browser: autonomously browse the web to complete tasks for you',
            id: '393c5860fa',
            description: 'Tooltip describing the Browser Agent mode suggestion',
        },
    }),
    [SearchMode.ASI]: defineMessages({
        /**
         * @deprecated use getSearchModeLabel function instead
         */
        name: {
            defaultMessage: 'Computer',
            id: 'ced136825e',
            description: 'Display name for the Computer mode in the mode selector',
        },
        description: {
            defaultMessage: 'Computer manages businesses, builds prototypes, creates dashboards, and more',
            id: '07dd63cf68',
            description: 'Subtitle describing the Computer mode in the mode selector',
        },
        suggestionTooltip: {
            defaultMessage: 'Use Computer',
            id: '70b6e49f1f',
            description: 'Tooltip describing the Computer mode suggestion',
        },
    }),
};
const SearchModeLabels = {
    [SearchMode.SEARCH]: defineMessage({
        defaultMessage: 'Search',
        id: 'b6660384f2',
        description: 'Short label for the Search mode used in navigation and headers',
    }),
    [SearchMode.RESEARCH]: defineMessage({
        defaultMessage: 'Deep research',
        id: 'a39cd04965',
        description: 'Short label for the Deep Research mode used in navigation and headers',
    }),
    [SearchMode.STUDY]: defineMessage({
        defaultMessage: 'Learn step by step',
        id: '66decd8278',
        description: 'Short label for the Study mode used in navigation and headers',
    }),
    [SearchMode.AGENTIC_RESEARCH]: defineMessage({
        defaultMessage: 'Model council',
        id: 'd27227d716',
        description: 'Short label for the Model Council mode used in navigation and headers',
    }),
    [SearchMode.BROWSER_AGENT]: defineMessage({
        defaultMessage: 'Control browser',
        id: 'ae220f45a6',
        description: 'Short label for the Browser Agent mode used in navigation and headers',
    }),
    [SearchMode.ASI]: defineMessage({
        defaultMessage: 'Computer',
        id: 'd09fb02ade',
        description: 'Short label for the Computer mode used in navigation and headers',
    }),
};
export const getSearchModeLabel = (searchMode) => {
    return SearchModeLabels[searchMode];
};
const SearchModeSubtitles = {
    [SearchMode.SEARCH]: defineMessage({
        defaultMessage: 'Fast answers to everyday questions',
        id: '0a262012ff',
        description: 'Compact subtitle for the Search mode shown in mode picker menus',
    }),
    [SearchMode.RESEARCH]: defineMessage({
        defaultMessage: 'In-depth reports, files, and apps',
        id: '3c38de0ddb',
        description: 'Compact subtitle for the Deep Research mode shown in mode picker menus',
    }),
    [SearchMode.STUDY]: defineMessage({
        defaultMessage: 'Interactive learning and quizzes',
        id: 'df763812d5',
        description: 'Compact subtitle for the Study mode shown in mode picker menus',
    }),
    [SearchMode.AGENTIC_RESEARCH]: defineMessage({
        defaultMessage: 'Multiple AI models at once',
        id: '01c92d0fe6',
        description: 'Compact subtitle for the Model Council mode shown in mode picker menus',
    }),
    [SearchMode.BROWSER_AGENT]: defineMessage({
        defaultMessage: 'Automate web tasks for you',
        id: 'b7a97de188',
        description: 'Compact subtitle for the Browser Agent mode shown in mode picker menus',
    }),
    [SearchMode.ASI]: defineMessage({
        defaultMessage: 'Manage businesses, build prototypes, create dashboards, and more',
        id: '6b06dc0a13',
        description: 'Compact subtitle for the Computer mode shown in mode picker menus',
    }),
};
const SidecarSearchModeSubtitles = {
    [SearchMode.ASI]: defineMessage({
        defaultMessage: 'Build prototypes, run research, automate work',
        id: '85968bcb94',
        description: 'Compact subtitle for the Computer mode shown in sidecar mode picker menus',
    }),
};
export const getSearchModeSubtitle = (searchMode) => {
    if (import.meta.env.VITE_IS_SIDECAR_BUILD) {
        return SidecarSearchModeSubtitles[searchMode] ?? SearchModeSubtitles[searchMode];
    }
    return SearchModeSubtitles[searchMode];
};
//# sourceMappingURL=search-modes-names.js.map